import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  { text: "POWERFUL APPS", cls: "text-magenta" },
  { text: "REAL PROBLEMS", cls: "text-outline" },
  { text: "IMPACTING LIVES", cls: "brand-gradient-text" },
  { text: "IDEAS TODAY", cls: "text-cyan" },
  { text: "IMPACT TOMORROW", cls: "text-ember" },
];

const SPARKLE_COLORS = ["#FF8A00", "#E0146B", "#0096C7", "#7C3AED", "#0D9488"];

export const EditorialMarquee = ({ className = "" }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative border-y border-ink/10 py-6 md:py-8 overflow-hidden select-none ${className}`}
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-display font-bold uppercase text-4xl md:text-6xl tracking-tighter px-6 md:px-10 ${item.cls}`}
          >
            {item.text}
          </span>
          <Sparkle
            className="w-6 h-6 md:w-8 md:h-8 shrink-0"
            style={{ color: SPARKLE_COLORS[i % SPARKLE_COLORS.length] }}
            strokeWidth={1.5}
          />
        </span>
      ))}
    </Marquee>
  </div>
);
